'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderRadius',
  key: 'radii',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/border-radius.js
// module id = 650
// module chunks = 3